import { Box, Typography } from "@mui/material";

const NoImageFound = ({width,height}) => (
    <Box
      sx={{
        width: `${width}px`,
        height: `${height}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme => theme.palette.mode === 'dark' ? 'grey.800' : 'grey.100',
        borderRadius: '12px',
        m: 1
      }}
    >
      <Typography variant="body2" color="text.secondary">
        No image available
      </Typography>
    </Box>
  );
export default NoImageFound;